module.exports = __webpack_public_path__ + "img/max-office-building-transfer.cf7509ae.svg";